module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('data-table', {
    attrs: {
      "title": "Finance Statement",
      "url": 'report/finance/summary' + (_vm.siteId ? '/' + _vm.siteId : ''),
      "table-ref": "fin-stmt-table",
      "fields": _vm.fields,
      "track-by": "siteName",
      "hide-org-badge": "",
      "search-placeholder": "Site Name, Site ID, Telco Name, Telco Site ID"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(props) {
        return [_c('org-badge', {
          attrs: {
            "name": props.rowData.name,
            "short-name": props.rowData.shortName,
            "color": props.rowData.colourCode,
            "no-full-name": _vm.isDesktop
          }
        })]
      }
    }, {
      key: "totals",
      fn: function(props) {
        return [(props.rowData.total > 0) ? _c('el-popover', {
          attrs: {
            "placement": "left",
            "width": "200",
            "trigger": "hover"
          }
        }, [(props.rowData.total > 0) ? _c('table', {
          staticClass: "el-table"
        }, [(props.rowData.currentRate > 0) ? _c('tr', [_c('td', [_vm._v("Current Rate")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatFloat(props.rowData.currentRate)))])])]) : _vm._e(), _vm._v(" "), (props.rowData.siteItems > 0) ? _c('tr', [_c('td', [_vm._v("Site Items")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatFloat(props.rowData.siteItems)))])])]) : _vm._e(), _vm._v(" "), (props.rowData.sharerItems > 0) ? _c('tr', [_c('td', [_vm._v("Sharer Items")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatFloat(props.rowData.sharerItems)))])])]) : _vm._e(), _vm._v(" "), (props.rowData.voSharerItems > 0) ? _c('tr', [_c('td', [_vm._v("V.O. Items")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatFloat(props.rowData.voSharerItems)))])])]) : _vm._e(), _vm._v(" "), (props.rowData.equipFees > 0) ? _c('tr', [_c('td', [_vm._v("Equip. Fees")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatFloat(props.rowData.equipFees)))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(_vm.formatFloat(props.rowData.total)))])], 1) : _c('el-button', {
          attrs: {
            "disabled": props.rowData.total === 0
          }
        }, [_vm._v(_vm._s(_vm.formatFloat(props.rowData.total)))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Finance Summary")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74f427d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/views/FinanceSummary.vue
// module id = 1642
// module chunks = 0